import _sfc_main from "./DayView.vue2.js";
/* empty css             */
import _export_sfc from "../../../_virtual/_plugin-vue_export-helper.js";
const DayView = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-510f1709"]]);
export {
  DayView as default
};
//# sourceMappingURL=DayView.vue.js.map
